(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-bundle-ladder"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cbl').forEach(function (root) {
  var rungs = root.querySelectorAll('[data-cbl-rung]');
  var cta = root.querySelector('[data-cbl-cta]');
  function select(r) {
    rungs.forEach(function (x) { x.classList.remove('is-on'); });
    r.classList.add('is-on');
    if (cta) {
      if (r.dataset.url) cta.setAttribute('href', r.dataset.url);
      if (r.dataset.cta) cta.textContent = r.dataset.cta;
    }
  }
  rungs.forEach(function (r) {
    r.addEventListener('click', function () { select(r); });
    r.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(r); }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centered-rail"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.crl').forEach(function(root){
  var rail=root.querySelector('[data-crl-rail]');
  if(!rail)return;
  function step(dir){
    var card=rail.querySelector('.crl__card');
    var w=card?card.getBoundingClientRect().width+20:400;
    rail.scrollBy({left:dir*w,behavior:'smooth'});
  }
  var p=root.querySelector('[data-crl-prev]');
  var n=root.querySelector('[data-crl-next]');
  if(p)p.addEventListener('click',function(){step(-1);});
  if(n)n.addEventListener('click',function(){step(1);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-wall"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cwl').forEach(function (root) {
  var rail = root.querySelector('[data-cwl-rail]');
  if (!rail) return;
  function step(dir) {
    var card = rail.querySelector('.cwl__card');
    var w = card ? card.getBoundingClientRect().width + 18 : 286;
    rail.scrollBy({ left: dir * w, behavior: 'smooth' });
  }
  var prev = root.querySelector('[data-cwl-prev]');
  var next = root.querySelector('[data-cwl-next]');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  class HotspotsSection {
    constructor() {
      console.log('HotspotsSection initialized');
      this.hotspots = document.querySelectorAll('.hotspot');
      console.log('Found hotspots:', this.hotspots.length);
      this.init();
    }

    init() {
      console.log('Initializing hotspots...');
      this.hotspots.forEach((hotspot, index) => {
        console.log(`Setting up hotspot ${index + 1}:`, hotspot);
        const button = hotspot.querySelector('.hotspot-button');
        if (button) {
          button.addEventListener('click', () => this.toggleHotspot(hotspot));
          console.log(`Hotspot ${index + 1} button click listener added`);
        } else {
          console.error(`No button found for hotspot ${index + 1}`);
        }

        // Close hotspot when clicking outside
        document.addEventListener('click', (e) => {
          if (!hotspot.contains(e.target)) {
            this.closeHotspot(hotspot);
          }
        });
      });
    }

    toggleHotspot(hotspot) {
      console.log('Toggling hotspot:', hotspot);
      const isActive = hotspot.classList.contains('active');
      console.log('Hotspot is active:', isActive);

      // Close all other hotspots
      this.hotspots.forEach((h) => {
        if (h !== hotspot) {
          this.closeHotspot(h);
        }
      });

      if (isActive) {
        this.closeHotspot(hotspot);
      } else {
        this.openHotspot(hotspot);
      }
    }

    openHotspot(hotspot) {
      console.log('Opening hotspot:', hotspot);

      // Check if hotspot is in the lower half of the image
      const imageContainer = hotspot.closest('.hotspots-image-container');
      const label = hotspot.querySelector('.hotspot-label');

      if (imageContainer && label) {
        const containerRect = imageContainer.getBoundingClientRect();
        const hotspotRect = hotspot.getBoundingClientRect();
        const hotspotCenterY = hotspotRect.top + hotspotRect.height / 2;
        const containerCenterY = containerRect.top + containerRect.height / 2;

        // If hotspot is below the middle of the image, position label above
        if (hotspotCenterY > containerCenterY) {
          label.classList.add('above');
        } else {
          label.classList.remove('above');
        }
      }

      hotspot.classList.add('active');
    }

    closeHotspot(hotspot) {
      console.log('Closing hotspot:', hotspot);
      hotspot.classList.remove('active');

      // Remove the above class when closing
      const label = hotspot.querySelector('.hotspot-label');
      if (label) {
        label.classList.remove('above');
      }
    }
  }

  // Initialize hotspots when DOM is ready
  console.log('Hotspots script loaded, document ready state:', document.readyState);
  if (document.readyState === 'loading') {
    console.log('Document still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOMContentLoaded fired, initializing HotspotsSection...');
      new HotspotsSection();
    });
  } else {
    console.log('Document already loaded, initializing HotspotsSection immediately...');
    new HotspotsSection();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
